import React from 'react';
import { ud } from '../Server'
import SiteDashBoard from './Dashboard/SiteDashboard'
import CorporateDashboard from './Dashboard/CorporateDashboard'
import UserDashboard from './Dashboard/userDashboard'
import SimulanisDashboard from './Dashboard/SimulanisDashboard'

class dashController extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }

    }
    render() {
        if (ud) {
            //*_*_*_*_*_*_**  0 ===> Simulanis_Admin **_*_*_*_*_*_*_*_*
            if (ud.usertype === 0) {
                return <SimulanisDashboard />;
            }

            //*_*_*_*_*_*_** 1 ===> C_Admin **_*_*_*_*_*_*_*
            else if (ud.usertype === 1) {
                return <CorporateDashboard />;
            }

            //*_*_*_*_*_*_** 2 ===>S_Admin **_*_*_*_*_*_*_*_*
            
            else if (ud.usertype === 2) {
            // else if (true) {
                return <SiteDashBoard />;
            }

            //*_*_*_*_*_*_**  3 ===> user **_*_*_*_*_*_*_*_*
            else if (ud.usertype === 3) {
                return <UserDashboard />;
            }



            else {
                return <div></div>
            }

        }
    }
}
export default dashController